module.exports = __webpack_public_path__ + "static/media/r9.015dbe8f.jpeg";